import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "title is-5 is-flex is-justify-content-space-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Tests ")
const _hoisted_4 = {
  key: 1,
  class: "tests-container"
}
const _hoisted_5 = { class: "is-flex mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label small-text mb-0" }, "Answer type:", -1)
const _hoisted_7 = { class: "small-text ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SCreateButton = _resolveComponent("SCreateButton")!
  const _component_SNotification = _resolveComponent("SNotification")!
  const _component_SListItem = _resolveComponent("SListItem")!
  const _component_CSurveyTest = _resolveComponent("CSurveyTest")!
  const _component_SModal = _resolveComponent("SModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_SCreateButton, {
          "button-text": "Create test",
          onClick: _ctx.onCreateTestButtonClick
        }, null, 8, ["onClick"])
      ]),
      (!_ctx.testsList?.length)
        ? (_openBlock(), _createBlock(_component_SNotification, {
            key: 0,
            title: "There are no tests"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testsList, (test) => {
              return (_openBlock(), _createBlock(_component_SListItem, {
                key: test.id,
                class: "is-clickable",
                title: test.name,
                description: test.description,
                "control-buttons": _ctx.getTestControlButtons(test),
                onClick: ($event: any) => (_ctx.openTestModal(test))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(test.answer.type), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["title", "description", "control-buttons", "onClick"]))
            }), 128))
          ]))
    ]),
    _createVNode(_component_SModal, {
      title: _ctx.selectedTest ? 'Edit test' : 'Create test',
      show: _ctx.showCreateTestModal,
      "on-close": _ctx.hideTestModal,
      "without-footer": ""
    }, {
      default: _withCtx(() => [
        (_ctx.showCreateTestModal)
          ? (_openBlock(), _createBlock(_component_CSurveyTest, {
              key: 0,
              "on-submit": _ctx.onSaveSurveyTest,
              "selected-test": _ctx.selectedTest
            }, null, 8, ["on-submit", "selected-test"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "show", "on-close"])
  ], 64))
}